import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import type { RootState } from '../store'
import {LogEntry, Member} from "../api/Models";
import {PURGE} from "redux-persist/es/constants";

// Define a type for the slice state
export interface LogState {
  logs: LogEntry[]
}

// Define the initial state using that type
const initialState: LogState = {
  logs: []
}

export const logsSlice = createSlice({
  name: 'logs',
  initialState,
  extraReducers: (builder) => {
    builder.addCase(PURGE, () => {
      return initialState
    })
  },
  reducers: {
    setLogEntries: (state, action: PayloadAction<LogEntry[]>) => {
      state.logs = action.payload
    },
    addLogEntry: (state, action: PayloadAction<LogEntry>) => {
      state.logs = [
        action.payload,
        ...state.logs
      ]
    },
    updateLogEntry: (state, action: PayloadAction<Partial<LogEntry>>) => {
      state.logs = state.logs.filter((l) => {
        if (l.id === action.payload.id) {
          return {
            ...l,
            ...action.payload
          }
        } else {
          return l
        }
      })
    },
    removeLogEntry: (state, action: PayloadAction<string>) => {
      state.logs = state.logs.filter((e) => e.id !== action.payload)
    }
  }
})

export const { setLogEntries, addLogEntry, removeLogEntry, updateLogEntry } = logsSlice.actions

// Other code such as selectors can use the imported `RootState` type
export const selectLogEntries = (state: RootState) => state.logs.logs
export const selectLogEntry = (state: RootState, id: string) => {
  return state.logs.logs.find((e) => e.id === id)
}
export const selectMemberLogEntries = (state: RootState, m: Member) =>  {
  return state.logs.logs.filter((log) => log.authorIds.includes(m.id))
}

export default logsSlice.reducer